export interface LanguageInfo {
    code: string,
    label: string,
    nativeLabel: string,
    countryCode: string,
    countryCodes: { countryCode: string, flag: string }[]
}

// export const languages: LanguageInfo[] = [
//     {"label": "Bulgarian", "code": "bg", "nativeLabel": "Български", "countryCode": "BG", countryCodes: ["BG"]},
//     {"label": "Chinese", "code": "zh", "nativeLabel": "中文", "countryCode": "CN", countryCodes: ["CN", "TW", "SG", "MY", "HK"]},
//     {"label": "Classic Arabic", "code": "ar", "nativeLabel": "العربية الفصحى", "countryCode": "SA", countryCodes: ["SA", "AE", "EG", "DZ", "MA", "LY", "OM", "KW", "QA"]},
//     {"label": "Croatian", "code": "hr", "nativeLabel": "Hrvatski", "countryCode": "HR", countryCodes: ["HR"]},
//     {"label": "Czech", "code": "cs", "nativeLabel": "Čeština", "countryCode": "CZ", countryCodes: ["CZ"]},
//     {"label": "Danish", "code": "da", "nativeLabel": "Dansk", "countryCode": "DK", countryCodes: ["DK"]},
//     {"label": "Dutch", "code": "nl", "nativeLabel": "Nederlands", "countryCode": "NL", countryCodes: ["NL", "BE", "SR"]},
//     {"label": "English", "code": "en", "nativeLabel": "English", "countryCode": "AU", countryCodes: ["US", "GB", "AU", "CA", "IN", "NZ", "ZA", "IE", "UK", "SE"]},
//     {"label": "Finnish", "code": "fi", "nativeLabel": "Suomi", "countryCode": "FI", countryCodes: ["FI"]},
//     {"label": "Filipino", "code": "tl", "nativeLabel": "Filipino", "countryCode": "PH", countryCodes: ["PH"]},
//     {"label": "French", "code": "fr", "nativeLabel": "Français", "countryCode": "FR", countryCodes: ["FR", "BE", "CA", "CH", "LU", "MC"]},
//     {"label": "German", "code": "de", "nativeLabel": "Deutsch", "countryCode": "DE", countryCodes: ["DE", "AT", "CH", "LI", "LU"]},
//     {"label": "Greek", "code": "el", "nativeLabel": "Ελληνικά", "countryCode": "GR", countryCodes: ["GR", "CY"]},
//     {"label": "Hindi", "code": "hi", "nativeLabel": "हिन्दी", "countryCode": "IN", countryCodes: ["IN", "FJ"]},
//     {"label": "Indonesian", "code": "id", "nativeLabel": "Bahasa Indonesia", "countryCode": "ID", countryCodes: ["ID"]},
//     {"label": "Italian", "code": "it", "nativeLabel": "Italiano", "countryCode": "IT", countryCodes: ["IT", "CH", "SM", "VA"]},
//     {"label": "Japanese", "code": "ja", "nativeLabel": "日本語", "countryCode": "JP", countryCodes: ["JP"]},
//     {"label": "Korean", "code": "ko", "nativeLabel": "한국어", "countryCode": "KR", countryCodes: ["KR"]},
//     {"label": "Malay", "code": "ms", "nativeLabel": "Bahasa Melayu", "countryCode": "MY", countryCodes: ["MY", "BN", "SG"]},
//     {"label": "Polish", "code": "pl", "nativeLabel": "Polski", "countryCode": "PL", countryCodes: ["PL"]},
//     {"label": "Portuguese", "code": "pt", "nativeLabel": "Português", "countryCode": "PT", countryCodes: ["PT", "BR", "MZ", "AO"]},
//     {"label": "Romanian", "code": "ro", "nativeLabel": "Română", "countryCode": "RO", countryCodes: ["RO", "MD"]},
//     {"label": "Russian", "code": "ru", "nativeLabel": "Русский", "countryCode": "RU", countryCodes: ["RU", "BY", "KZ", "KG", "UA"]},
//     {"label": "Slovak", "code": "sk", "nativeLabel": "Slovenčina", "countryCode": "SK", countryCodes: ["SK"]},
//     {"label": "Spanish", "code": "es", "nativeLabel": "Español", "countryCode": "ES", countryCodes: ["ES", "MX", "AR", "CO", "CL", "PE", "VE", "US"]},
//     {"label": "Swedish", "code": "sv", "nativeLabel": "Svenska", "countryCode": "SE", countryCodes: ["SE", "FI"]},
//     {"label": "Tamil", "code": "ta", "nativeLabel": "தமிழ்", "countryCode": "IN", countryCodes: ["IN", "LK", "SG", "MY"]},
//     {"label": "Turkish", "code": "tr", "nativeLabel": "Türkçe", "countryCode": "TR", countryCodes: ["TR", "CY"]},
//     {"label": "Ukrainian", "code": "uk", "nativeLabel": "Українська", "countryCode": "UA", countryCodes: ["UA"]}
// ];

export const languages: LanguageInfo[] = [
    {
        "label": "Bulgarian",
        "code": "bg",
        "nativeLabel": "Български",
        "countryCode": "BG",
        "countryCodes": [
            {"countryCode": "BG", "flag": "🇧🇬"}
        ]
    },
    {
        "label": "Chinese",
        "code": "zh",
        "nativeLabel": "中文",
        "countryCode": "CN",
        "countryCodes": [
            {"countryCode": "CN", "flag": "🇨🇳"},
            {"countryCode": "TW", "flag": "🇹🇼"},
            // {"countryCode": "SG", "flag": "🇸🇬"},
            // {"countryCode": "MY", "flag": "🇲🇾"},
            {"countryCode": "HK", "flag": "🇭🇰"}
        ]
    },
    {
        "label": "Classic Arabic",
        "code": "ar",
        "nativeLabel": "العربية الفصحى",
        "countryCode": "AE",
        "countryCodes": [
            {"countryCode": "SA", "flag": "🇸🇦"},
            {"countryCode": "AE", "flag": "🇦🇪"},
            {"countryCode": "EG", "flag": "🇪🇬"},
            // {"countryCode": "DZ", "flag": "🇩🇿"},
            // {"countryCode": "MA", "flag": "🇲🇦"},
            // {"countryCode": "LY", "flag": "🇱🇾"},
            // {"countryCode": "OM", "flag": "🇴🇲"},
            // {"countryCode": "KW", "flag": "🇰🇼"},
            {"countryCode": "QA", "flag": "🇶🇦"}
        ]
    },
    // {
    //     "label": "Croatian",
    //     "code": "hr",
    //     "nativeLabel": "Hrvatski",
    //     "countryCode": "HR",
    //     "countryCodes": [
    //         {"countryCode": "HR", "flag": "🇭🇷"}
    //     ]
    // },
    {
        "label": "Czech",
        "code": "cs",
        "nativeLabel": "Čeština",
        "countryCode": "CZ",
        "countryCodes": [
            {"countryCode": "CZ", "flag": "🇨🇿"}
        ]
    },
    {
        "label": "Danish",
        "code": "da",
        "nativeLabel": "Dansk",
        "countryCode": "DK",
        "countryCodes": [
            {"countryCode": "DK", "flag": "🇩🇰"}
        ]
    },
    {
        "label": "Dutch",
        "code": "nl",
        "nativeLabel": "Nederlands",
        "countryCode": "NL",
        "countryCodes": [
            {"countryCode": "NL", "flag": "🇳🇱"},
            {"countryCode": "BE", "flag": "🇧🇪"},
            {"countryCode": "SR", "flag": "🇸🇷"}
        ]
    },
    {
        "label": "English",
        "code": "en",
        "nativeLabel": "English",
        "countryCode": "GB",
        "countryCodes": [
            {"countryCode": "US", "flag": "🇺🇸"},
            {"countryCode": "GB", "flag": "🇬🇧"},
            {"countryCode": "AU", "flag": "🇦🇺"},
            {"countryCode": "CA", "flag": "🇨🇦"},
            {"countryCode": "IN", "flag": "🇮🇳"},
            {"countryCode": "NZ", "flag": "🇳🇿"},
            // {"countryCode": "ZA", "flag": "🇿🇦"},
            // {"countryCode": "IE", "flag": "🇮🇪"},
            // {"countryCode": "UK", "flag": "🇬🇧"},
            // {"countryCode": "SE", "flag": "🇸🇪"},
            // {"countryCode": "WLS", "flag": "🏴󠁧󠁢󠁷󠁬󠁳󠁿"}
        ]
    },
    {
        "label": "Finnish",
        "code": "fi",
        "nativeLabel": "Suomi",
        "countryCode": "FI",
        "countryCodes": [
            {"countryCode": "FI", "flag": "🇫🇮"}
        ]
    },
    // {
    //     "label": "Filipino",
    //     "code": "tl",
    //     "nativeLabel": "Filipino",
    //     "countryCode": "PH",
    //     "countryCodes": [
    //         {"countryCode": "PH", "flag": "🇵🇭"}
    //     ]
    // },
    {
        "label": "French",
        "code": "fr",
        "nativeLabel": "Français",
        "countryCode": "FR",
        "countryCodes": [
            {"countryCode": "FR", "flag": "🇫🇷"},
            {"countryCode": "BE", "flag": "🇧🇪"},
            {"countryCode": "CA", "flag": "🇨🇦"},
            {"countryCode": "CH", "flag": "🇨🇭"},
            {"countryCode": "LU", "flag": "🇱🇺"},
            {"countryCode": "MC", "flag": "🇲🇨"}
        ]
    },
    {
        "label": "German",
        "code": "de",
        "nativeLabel": "Deutsch",
        "countryCode": "DE",
        "countryCodes": [
            {"countryCode": "DE", "flag": "🇩🇪"},
            {"countryCode": "AT", "flag": "🇦🇹"},
            {"countryCode": "CH", "flag": "🇨🇭"},
            {"countryCode": "LI", "flag": "🇱🇮"},
            {"countryCode": "LU", "flag": "🇱🇺"}
        ]
    },
    {
        "label": "Greek",
        "code": "el",
        "nativeLabel": "Ελληνικά",
        "countryCode": "GR",
        "countryCodes": [
            {"countryCode": "GR", "flag": "🇬🇷"},
            {"countryCode": "CY", "flag": "🇨🇾"}
        ]
    },
    {
        "label": "Hindi",
        "code": "hi",
        "nativeLabel": "हिन्दी",
        "countryCode": "IN",
        "countryCodes": [
            {"countryCode": "IN", "flag": "🇮🇳"},
            {"countryCode": "FJ", "flag": "🇫🇯"}
        ]
    },
    {
        "label": "Indonesian",
        "code": "id",
        "nativeLabel": "Bahasa Indonesia",
        "countryCode": "ID",
        "countryCodes": [
            {"countryCode": "ID", "flag": "🇮🇩"}
        ]
    },
    {
        "label": "Italian",
        "code": "it",
        "nativeLabel": "Italiano",
        "countryCode": "IT",
        "countryCodes": [
            {"countryCode": "IT", "flag": "🇮🇹"},
            {"countryCode": "CH", "flag": "🇨🇭"},
            {"countryCode": "SM", "flag": "🇸🇲"},
            {"countryCode": "VA", "flag": "🇻🇦"}
        ]
    },
    {
        "label": "Japanese",
        "code": "ja",
        "nativeLabel": "日本語",
        "countryCode": "JP",
        "countryCodes": [
            {"countryCode": "JP", "flag": "🇯🇵"}
        ]
    },
    {
        "label": "Korean",
        "code": "ko",
        "nativeLabel": "한국어",
        "countryCode": "KR",
        "countryCodes": [
            {"countryCode": "KR", "flag": "🇰🇷"}
        ]
    },
    {
        "label": "Malay",
        "code": "ms",
        "nativeLabel": "Bahasa Melayu",
        "countryCode": "MY",
        "countryCodes": [
            {"countryCode": "MY", "flag": "🇲🇾"},
            {"countryCode": "BN", "flag": "🇧🇳"},
            {"countryCode": "SG", "flag": "🇸🇬"}
        ]
    },
    {
        "label": "Polish",
        "code": "pl",
        "nativeLabel": "Polski",
        "countryCode": "PL",
        "countryCodes": [
            {"countryCode": "PL", "flag": "🇵🇱"}
        ]
    },
    {
        "label": "Portuguese",
        "code": "pt",
        "nativeLabel": "Português",
        "countryCode": "BR",
        "countryCodes": [
            {"countryCode": "PT", "flag": "🇵🇹"},
            {"countryCode": "BR", "flag": "🇧🇷"},
            {"countryCode": "MZ", "flag": "🇲🇿"},
            {"countryCode": "AO", "flag": "🇦🇴"}
        ]
    },
    {
        "label": "Romanian",
        "code": "ro",
        "nativeLabel": "Română",
        "countryCode": "RO",
        "countryCodes": [
            {"countryCode": "RO", "flag": "🇷🇴"},
            {"countryCode": "MD", "flag": "🇲🇩"}
        ]
    },
    {
        "label": "Russian",
        "code": "ru",
        "nativeLabel": "Русский",
        "countryCode": "RU",
        "countryCodes": [
            {"countryCode": "RU", "flag": "🇷🇺"},
            {"countryCode": "BY", "flag": "🇧🇾"},
            {"countryCode": "KZ", "flag": "🇰🇿"},
            {"countryCode": "KG", "flag": "🇰🇬"},
            {"countryCode": "UA", "flag": "🇺🇦"}
        ]
    },
    {
        "label": "Slovak",
        "code": "sk",
        "nativeLabel": "Slovenčina",
        "countryCode": "SK",
        "countryCodes": [
            {"countryCode": "SK", "flag": "🇸🇰"}
        ]
    },
    {
        "label": "Spanish",
        "code": "es",
        "nativeLabel": "Español",
        "countryCode": "ES",
        "countryCodes": [
            {"countryCode": "ES", "flag": "🇪🇸"},
            {"countryCode": "MX", "flag": "🇲🇽"},
            {"countryCode": "AR", "flag": "🇦🇷"},
            {"countryCode": "CO", "flag": "🇨🇴"},
            // {"countryCode": "CL", "flag": "🇨🇱"},
            // {"countryCode": "PE", "flag": "🇵🇪"},
            // {"countryCode": "VE", "flag": "🇻🇪"},
            // {"countryCode": "US", "flag": "🇺🇸"}
        ]
    },
    {
        "label": "Swedish",
        "code": "sv",
        "nativeLabel": "Svenska",
        "countryCode": "SE",
        "countryCodes": [
            {"countryCode": "SE", "flag": "🇸🇪"},
            {"countryCode": "FI", "flag": "🇫🇮"}
        ]
    },
    {
        "label": "Tamil",
        "code": "ta",
        "nativeLabel": "தமிழ்",
        "countryCode": "IN",
        "countryCodes": [
            {"countryCode": "IN", "flag": "🇮🇳"},
            {"countryCode": "LK", "flag": "🇱🇰"},
            {"countryCode": "SG", "flag": "🇸🇬"},
            {"countryCode": "MY", "flag": "🇲🇾"}
        ]
    },
    {
        "label": "Turkish",
        "code": "tr",
        "nativeLabel": "Türkçe",
        "countryCode": "TR",
        "countryCodes": [
            {"countryCode": "TR", "flag": "🇹🇷"},
            {"countryCode": "CY", "flag": "🇨🇾"}
        ]
    },
    {
        "label": "Ukrainian",
        "code": "uk",
        "nativeLabel": "Українська",
        "countryCode": "UA",
        "countryCodes": [
            {"countryCode": "UA", "flag": "🇺🇦"}
        ]
    }
];



export const chooseLanguageTranslations: { [key: string]: string } = {
    "bg": "Изберете език",
    "zh": "选择语言",
    "ar": "اختر اللغة",
    "hr": "Odaberite jezik",
    "cs": "Vyberte jazyk",
    "da": "Vælg sprog",
    "nl": "Kies taal",
    "en": "Choose language",
    "fi": "Valitse kieli",
    "tl": "Pumili ng wika",
    "fr": "Choisissez la langue",
    "de": "Sprache wählen",
    "el": "Επιλέξτε γλώσσα",
    "hi": "भाषा चुनें",
    "id": "Pilih bahasa",
    "it": "Scegli la lingua",
    "ja": "言語を選択",
    "ko": "언어 선택",
    "ms": "Pilih bahasa",
    "pl": "Wybierz język",
    "pt": "Escolha o idioma",
    "ro": "Alege limba",
    "ru": "Выберите язык",
    "sk": "Vyberte jazyk",
    "es": "Elige idioma",
    "sv": "Välj språk",
    "ta": "மொழியைத் தேர்ந்தெடுங்கள்",
    "tr": "Dil seçin",
    "uk": "Оберіть мову"
}

export function getLanguageInfoByCode(code: string): LanguageInfo | undefined {
    return languages.find(lang => lang.code === code);
}

export function getLanguageInfoByLabel(label: string): LanguageInfo | undefined {
    return languages.find(lang => lang.label === label);
}

export function getLanguageSwitcherDisplayTextTranslation(code: string): string {
    return chooseLanguageTranslations[code]
}

// Get the language label by code and country code because some country codes are shared between languages
export function getLabelByCodeAndCountryCode(code: string, countryCode: string): string | null {
    const language = languages.find(lang =>
        lang.code === code && lang.countryCodes.some(cc => cc.countryCode === countryCode)
    );
    return language ? language.label : null;
}

export function getFlagByCodeAndCountryCode(countryCode: string, code: string): string | null {
    const language = languages.find(lang => lang.code === code);

    if (language) {
        const country = language.countryCodes.find(c => c.countryCode === countryCode);
        return country ? country.flag : null;
    }

    return null;
}
